var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { msg, localized } from '@lit/localize';
let TextAreaNodeInput = class TextAreaNodeInput extends LitElement {
    onInputChange(event) {
        const inputElement = event.target;
        this.input.value = inputElement.value;
        this.dispatchEvent(new CustomEvent('node-input-change', {
            detail: { key: this.key, input: this.input },
            bubbles: true,
            composed: true
        }));
    }
    render() {
        return html `
            <input-text-area
                .value=${this.input?.value || ''}
                .placeholder=${this.input?.placeholder || msg('Enter text', { id: 'nodeInput.placeholder.enterText', desc: 'Text node input placeholder' })}
                @input-text-area=${this.onInputChange}
            ></input-text-area>
        `;
    }
};
TextAreaNodeInput.styles = css `
      .text-area-node-input {
        width: 100%;
        padding: 6px 9px; /* Réduction de 25% */
        font-size: 10.5px; /* Réduction de 25% */
        border: 1px solid #ccc;
        border-radius: 3px; /* Réduction de 25% */
        box-sizing: border-box;
        transition: border-color 0.3s ease, box-shadow 0.3s ease;
        resize: vertical;
        min-height: 60px; /* Réduction de 25% */
      }

      .text-area-node-input:focus {
        border-color: #555ab9;
        box-shadow: 0 0 3px rgba(85, 90, 185, 0.5); /* Réduction de 25% */
        outline: none;
      }

      .text-area-node-input::placeholder {
        color: #aaa;
        font-style: italic;
      }
    `;
__decorate([
    property({ type: String })
], TextAreaNodeInput.prototype, "key", void 0);
__decorate([
    property({ type: Object })
], TextAreaNodeInput.prototype, "input", void 0);
TextAreaNodeInput = __decorate([
    localized(),
    customElement('text-area-node-input')
], TextAreaNodeInput);
export { TextAreaNodeInput };
//# sourceMappingURL=TextAreaNodeInput.js.map